import createCellRenderer from './createCellRenderer'
import EditableGrid, { createEditableGrid } from './EditableGrid'
import GenericEditableGrid from './generic-editable-grid'
import {
  createStore as createReduxStore,
  combineReducers,
  applyMiddleware,
} from 'redux'
import * as defaultReducers from './reducers'
import GenericEditor from './GenericEditor'
// import NumberEditor from './NumeralEditor'
import { createGridTools } from './index'
import createCellEditor from './createCellEditor'
import thunk from 'redux-thunk'

import * as ANS from './action-names'
export * from './RegexCheckedEditor'

// import createCustomActions,* as actions from './actions'
// import createSelectors from './selectors'
// const selectors = createSelectors({})
// const customActions = createCustomActions(selectors)
// export const gridTools = { ...selectors,...actions, ...customActions }
export const gridTools = createGridTools({})

export * from './action-names'
export {
  createCellRenderer,
  EditableGrid,
  createEditableGrid,
  GenericEditor,
  createCellEditor,
  GenericEditableGrid,
}
export * from './utils'
export const dataActions = [
  ANS.SET_CONTENT,
  ANS.SET_DATA,
  ANS.COMMIT_EDIT,
  ANS.PASTE_DATA,
]

export const createStore = (initialStore, customReducers) =>
  createReduxStore(
    combineReducers({
      ...defaultReducers,
      ...customReducers,
    }),
    initialStore,
    applyMiddleware(thunk)
  )
